import React from 'react';
import Modal from 'react-bootstrap/Modal';
import InputField from '../Reusable/InputField';
import withTranslations from '../../utils/HighOrderComponent';
import ButtonSave from '../Reusable/ButtonSave';
import { handleErrorMessage } from '../../utils';
import Tooltip from '@material-ui/core/Tooltip';
import {
  uploadFileDecisionTypeAllowedTypes,
  uploadFileMaxSize,
} from '../../constants/globals.js';
import ComboBoxAutocomplete from '../Reusable/ComboBoxAutocomplete';

class ModalForAddDecisionType extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      description: '',
      uploadedFile: '',
      decisionType: '',

      errors: {},
    };
  }

  onFileChange = (e) => {
    this.setState({
      uploadedFile: e.target.files.length > 0 && e.target.files[0],
    });
  };

  handleClose = () => {
    this.props.handleClose();
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleClientValidation = () => {
    let hasError = false;

    let errors = {};

    if (!this.state.name) {
      errors['name'] = this.props.t.Errors.name;
      hasError = true;
    }

    if (!this.state.uploadedFile) {
      errors['uploadedFile'] = this.props.t.Errors.fileNotUploaded;
      hasError = true;
    }

    if (this.state.uploadedFile) {
      if (
        !uploadFileDecisionTypeAllowedTypes.includes(
          this.state.uploadedFile.type
        )
      ) {
        errors['uploadedFile'] = this.props.t.Errors.invalidFileFormat;
        hasError = true;
      }
    }

    if (this.state.uploadedFile.size > uploadFileMaxSize) {
      errors['uploadedFile'] = this.props.t.Errors.invalidFileSize;
      hasError = true;
    }

    this.setState({ errors });
    return hasError;
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (this.handleClientValidation()) {
      return;
    }

    const newDecisionType = {
      name: this.state.name,
      description: this.state.description,
    };

    if (this.state.uploadedFile) {
      let formData = new FormData();

      formData.append('file', this.state.uploadedFile);
      formData.append('name', this.state.uploadedFile.name);
      formData.append(
        'decisionType',
        new Blob([JSON.stringify(newDecisionType)], {
          type: 'application/json',
        })
      );
      this.props.handleAddDecisionTypeWithAttachment(
        formData,
        this.state.decisionType
      );
    } else {
      this.props.handleAdd(newDecisionType);
    }
  };

  changeComboAutocompleteValue = (name, newValue) => {
    this.setState({
      name: newValue.text,
      decisionType: newValue.value,
    });
  };

  render() {
    const { error, t, enums } = this.props || {},
      { Placeholders, Labels } = t || {},
      { DecisionTypeTypes } = enums || [];

    let fileTitlePreview;
    if (this.state.uploadedFile) {
      fileTitlePreview = this.state.uploadedFile.name;
    } else {
      fileTitlePreview = Labels.fileTitlePreview;
    }

    return (
      <Modal
        show={this.props.show}
        onHide={this.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className={this.props.secondModal && 'secondModal'}
      >
        <Modal.Header closeButton>
          <Modal.Body>
            <h5 className="title mb-4">{Labels.title}</h5>
            <form onSubmit={this.handleSubmit}>
              <div className="col-md-12">
                <div className="form-group">
                  <ComboBoxAutocomplete
                    data={DecisionTypeTypes}
                    text={(decisionType) => decisionType.text}
                    changeValue={(newValue) =>
                      this.changeComboAutocompleteValue('name', newValue)
                    }
                    wholeObject
                    placeholder={Placeholders.name}
                    error={handleErrorMessage(
                      error,
                      'name',
                      this.state.errors.name
                    )}
                    updateValue={Object.values(DecisionTypeTypes).find(
                      (type) => type.text === this.state.name
                    )}
                  />
                </div>
                <div className="form-group">
                  <InputField
                    name="description"
                    placeholder={Placeholders.description}
                    onChange={this.onChange}
                    value={this.state.description}
                    multiline={true}
                    rows={3}
                    error={handleErrorMessage(
                      error,
                      'description',
                      this.state.errors.description
                    )}
                  />
                </div>

                <div className="d-flex mt-4 input-one-document">
                  <label
                    className="col-md-12 without-margin-bottom custom-file-upload"
                    style={{ cursor: 'pointer' }}
                  >
                    <input
                      type="file"
                      accept=".docx"
                      style={{ display: 'none' }}
                      onChange={this.onFileChange}
                    />
                    <Tooltip
                      title={this.props.t.Tooltips.decisionAttachment}
                      placement="top"
                      arrow={true}
                    >
                      <i className="fas fa-paperclip fa-2x" />
                    </Tooltip>
                    {fileTitlePreview}
                    <i></i>
                  </label>
                  <hr className="lineBreaker-one-document " />
                </div>
                <div className="text-center">
                  {this.state.errors.uploadedFile && (
                    <b>
                      <div style={{ color: 'red' }}>
                        {this.state.errors.uploadedFile}
                      </div>
                    </b>
                  )}
                </div>
              </div>
              <br />
              <div className="row">
                <ButtonSave onClick={this.handleSubmit} />
              </div>
            </form>
          </Modal.Body>
        </Modal.Header>
      </Modal>
    );
  }
}

export default withTranslations(
  ModalForAddDecisionType,
  'ModalForAddDecisionType'
);
